import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
    <div  style={{backgroundImage: `url("./images/bgmud.jpg")`}} className="bg-cover bg-no-repeat bg-bottom">
    <div className="container mx-auto mt-10 relative items-center justify-center py-16 px-4" >
          <div className="flex flex-wrap md:justify-between md:items-stretch">
            <div className=""><h3 className="text-2xl leading-12 font-semibold text-white tracking-wider">Reprenez le contrôle de votre santé<br/>Inscrivez-vous à notre Newsletter</h3></div>
            <div className="py-4"><input type="text" className="py-3 px-4 bg-[#7D6146] -mr-2 rounded-tl-md	rounded-bl-md w-56 md:w-80" placeholder="Votre email"/> <button className="bg-white py-3 px-4 text-[#4B2B09] font-semibold rounded-tr-md	rounded-br-md	">Soumettre</button></div>
          </div>
      </div>
  </div>
  <div  style={{backgroundImage: `url("./images/bg-4.jpg")`}} className="bg-cover bg-no-repeat relative">
    <div className="container mx-auto  items-center justify-center py-12  px-4" >
          <div className="flex text-center py-8">
            <div className="basis-full md:basis-5/12 border-[#3E3D68] border-t-2 py-10">
              </div>
              <div className="basis-full md:basis-2/12 text-center">
              <img src="./images/Seva-logo.png"  className="m-auto -mt-8 mb-6"/> 
              <a href="mailto:hello@seva.io" className="text-[#9392C7] m-auto ">info@centre-seva.com</a>
              </div>
              <div className="basis-full md:basis-5/12 border-[#3E3D68] border-t-2 py-10">
              </div>
          </div>
          <div className="flex text-center py-8">
            <div className="basis-full flex-col flex md:basis-5/12 border-[#3E3D68] ">
              <a href="" className="text-[#9392C7] mb-2">Services</a>
              <a href="/#about" className="text-[#9392C7] mb-2">Qui Sommes-nous?</a>
              <a href="" className="text-[#9392C7] mb-2">Votre Session en Ligne</a>
            </div>
            <div className="basis-full  md:basis-2/12 px-2">
           
              <div  className="flex justify-between items-stretch -m-2">
                <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.407 13.2143V9.59421C10.407 8.59514 11.1918 7.78416 12.1586 7.78416H13.9103V3.25903H10.407C7.50443 3.25903 5.152 5.68987 5.152 8.68918V13.2143H1.64868V17.7394H5.152V32.2198H10.407V17.7394H13.9103L15.662 13.2143H10.407Z" fill="#9392C7"/>
                  </svg>
                  <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_842_8980)">
                  <path d="M5.71346 8.06458H0V24.0323H5.71346V8.06458Z" fill="#9392C7"/>
                  <path d="M21.2757 8.25158C21.2151 8.23456 21.1571 8.21529 21.0935 8.19941C21.0168 8.18353 20.9401 8.17049 20.8621 8.15858C20.559 8.10358 20.2265 8.06445 19.8367 8.06445C16.5059 8.06445 14.3933 10.2668 13.6972 11.1174V8.06445H7.98438V24.0322H13.6978V15.3225C13.6978 15.3225 18.0154 9.85572 19.8373 13.8709V24.0322H25.5495V13.2568C25.5489 10.8441 23.7301 8.83392 21.2757 8.25158Z" fill="#9392C7"/>
                  <path d="M5.58871 3.34696C5.58871 4.74981 4.33749 5.88729 2.79435 5.88729C1.25122 5.88729 0 4.74981 0 3.34696C0 1.94412 1.25122 0.806641 2.79435 0.806641C4.33749 0.806641 5.58871 1.94412 5.58871 3.34696Z" fill="#9392C7"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_842_8980">
                  <rect width="25.5484" height="23.2258" fill="white" transform="translate(0 0.806641)"/>
                  </clipPath>
                  </defs>
                  </svg>
                  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_842_8985)">
                  <path d="M18.3629 0.806641H8.34677C3.73779 0.806641 0 4.38192 0 8.79051V18.3712C0 22.7798 3.73779 26.355 8.34677 26.355H18.3629C22.9719 26.355 26.7097 22.7798 26.7097 18.3712V8.79051C26.7097 4.38192 22.9719 0.806641 18.3629 0.806641ZM24.2056 18.3712C24.2056 21.4531 21.5849 23.9599 18.3629 23.9599H8.34677C5.12479 23.9599 2.50403 21.4531 2.50403 18.3712V8.79051C2.50403 5.70861 5.12544 3.2018 8.34677 3.2018H18.3629C21.5849 3.2018 24.2056 5.70924 24.2056 8.79051V18.3712Z" fill="#9392C7"/>
                  <path d="M13.3553 7.19421C9.6677 7.19421 6.67786 10.0541 6.67786 13.5813C6.67786 17.1086 9.6677 19.9684 13.3553 19.9684C17.0429 19.9684 20.0327 17.1086 20.0327 13.5813C20.0327 10.0541 17.0429 7.19421 13.3553 7.19421ZM13.3553 17.5732C11.0547 17.5732 9.18189 15.7819 9.18189 13.5813C9.18189 11.3789 11.0547 9.58938 13.3553 9.58938C15.6559 9.58938 17.5287 11.3789 17.5287 13.5813C17.5287 15.7819 15.6559 17.5732 13.3553 17.5732Z" fill="#9392C7"/>
                  <path d="M21.4215 6.71504C21.4215 7.18534 21.0231 7.56582 20.532 7.56582C20.041 7.56582 19.6426 7.18472 19.6426 6.71504C19.6426 6.24536 20.041 5.86426 20.532 5.86426C21.0231 5.86363 21.4215 6.24474 21.4215 6.71504Z" fill="#9392C7"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_842_8985">
                  <rect width="26.7097" height="25.5484" fill="white" transform="translate(0 0.806641)"/>
                  </clipPath>
                  </defs>
                  </svg>

                </div>
                <div className=" m-auto"><img src="./images/Line.png" className="m-auto mt-4"></img></div>  
            </div>
            <div className="basis-full flex-col flex md:basis-5/12 border-[#3E3D68] ">
            <a href="/contact" className="text-[#9392C7] mb-2">Contact </a> 
            <a href="" className="text-[#9392C7] mb-2">Terms & Conditions</a>
            <a href="" className="text-[#9392C7] mb-2">Politique de Confidentialité</a>
            </div>
          </div>   
          
      </div>
      <div className=" absolute bottom-0 left-0"><img src="./images/footer.png" className="m-auto mt-4"></img></div>          
  </div>
  <div className="bg-[#1B1B54] pb-2 pt-4"><p className="text-center text-[#9A97C1]">SEVA © 2024. All rights reserved.</p></div>
  </>
  )
}